import React, { useState, useEffect } from 'react';
import styles from './ClientForm.module.css';

const ClientForm = ({ onSubmit, initialData = null, onCancel = null }) => {
  const [formData, setFormData] = useState({
    clientName: '',
    channelName: '',
    email: '',
    mobile: '',
    startDate: '',
    totalAmount: '',
    receivedAmount: '',
    paymentDate: new Date().toISOString().split('T')[0]
  });

  useEffect(() => {
    if (initialData) {
      setFormData({
        clientName: initialData.name || initialData.clientName || '',
        channelName: initialData.channel || initialData.channelName || '',
        email: initialData.email || '',
        mobile: initialData.mobile || '',
        startDate: initialData.startDate || '',
        totalAmount: initialData.totalAmount || '',
        receivedAmount: initialData.receivedAmount || '',
        paymentDate: initialData.lastPaymentDate ? new Date(initialData.lastPaymentDate).toISOString().split('T')[0] : new Date().toISOString().split('T')[0]
      });
    }
  }, [initialData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSubmit) {
      onSubmit(formData);
    }
    if (!initialData) {
      setFormData({
        clientName: '',
        channelName: '',
        email: '',
        mobile: '',
        startDate: '',
        totalAmount: '',
        receivedAmount: '',
        paymentDate: new Date().toISOString().split('T')[0]
      });
    }
  };

  return (
    <div className={styles.formContainer}>
      <h2 className={styles.formTitle}>{initialData ? 'Edit Client' : 'Add New Client'}</h2>
      <form onSubmit={handleSubmit}>
        <div className={styles.formGrid}>
          <div className={styles.formGroup}>
            <label className={styles.label} htmlFor="clientName">Client Name</label>
            <input
              type="text"
              id="clientName"
              name="clientName"
              className={styles.input}
              placeholder="e.g. John Doe"
              value={formData.clientName}
              onChange={handleChange}
              required
            />
          </div>
          
          <div className={styles.formGroup}>
            <label className={styles.label} htmlFor="channelName">Channel Name</label>
            <input
              type="text"
              id="channelName"
              name="channelName"
              className={styles.input}
              placeholder="e.g. Tech Reviews"
              value={formData.channelName}
              onChange={handleChange}
              required
            />
          </div>

          <div className={styles.formGroup}>
            <label className={styles.label} htmlFor="email">Email Address <span style={{ color: '#64748b', fontSize: '0.85em', fontWeight: 'normal' }}>(Optional)</span></label>
            <input
              type="email"
              id="email"
              name="email"
              className={styles.input}
              placeholder="john@example.com"
              value={formData.email}
              onChange={handleChange}
            />
          </div>

          <div className={styles.formGroup}>
            <label className={styles.label} htmlFor="mobile">Mobile Number <span style={{ color: '#64748b', fontSize: '0.85em', fontWeight: 'normal' }}>(Optional)</span></label>
            <input
              type="tel"
              id="mobile"
              name="mobile"
              className={styles.input}
              placeholder="+1 (555) 000-0000"
              value={formData.mobile}
              onChange={handleChange}
            />
          </div>

          <div className={styles.formGroup}>
            <label className={styles.label} htmlFor="startDate">Start Date</label>
            <input
              type="date"
              id="startDate"
              name="startDate"
              className={styles.input}
              value={formData.startDate}
              onChange={handleChange}
              required
            />
          </div>

          <div className={styles.formGroup}>
            <label className={styles.label}>Total Amount (₹)</label>
            <div className={styles.amountInputGroup}>
              <span style={{ display: 'flex', alignItems: 'center', padding: '0 12px', backgroundColor: '#f1f5f9', border: '1px solid #cbd5e1', borderRadius: '8px', color: '#64748b' }}>₹</span>
              <input
                type="number"
                name="totalAmount"
                className={`${styles.input} ${styles.amountInput}`}
                placeholder="e.g. 1500"
                min="0"
                step="0.01"
                value={formData.totalAmount}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className={styles.formGroup}>
            <label className={styles.label} htmlFor="receivedAmount">Advance Received</label>
            <input
              type="number"
              id="receivedAmount"
              name="receivedAmount"
              className={styles.input}
              placeholder="e.g. 500"
              min="0"
              step="0.01"
              value={formData.receivedAmount}
              onChange={handleChange}
            />
          </div>
          
          <div className={styles.formGroup}>
            <label className={styles.label} htmlFor="paymentDate">Payment Received On</label>
            <input
              type="date"
              id="paymentDate"
              name="paymentDate"
              className={styles.input}
              value={formData.paymentDate}
              onChange={handleChange}
              required={parseFloat(formData.receivedAmount) > 0}
            />
          </div>
        </div>
        
        <div style={{ display: 'flex', gap: '12px', marginTop: '16px' }}>
          <button type="submit" className={styles.submitButton}>
            {initialData ? 'Save Changes' : 'Save Client'}
          </button>
          {onCancel && (
            <button type="button" onClick={onCancel} className={styles.cancelButton}>
              Cancel
            </button>
          )}
        </div>
      </form>
    </div>
  );
};

export default ClientForm;
